<div class="loader">
  <span class="loader-text">{{ 'common.spinnerLoading_hint' | cxTranslate }}</span>
</div>
